/**
 * 排出事業者の検索ダイアログ
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const emission_member = {
  namespaced: true,
  state: {},
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     *
     * @param commit
     * @param params
     * @property params.free_word { String }
     * @property code { string } 事業場コード
     * @property subscriber_no { string } 加入者番号
     * @property name { string } 名称
     * @property billing_address_name { string } 請求先名
     * @property page { number } ページ番号
     * @return {Promise<unknown>}
     */
    index ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/masters/search/emission_members`, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
  },
  mutations: {},
}
export default emission_member

